<template><div><h1 id="ruckstandsliste" tabindex="-1"><a class="header-anchor" href="#ruckstandsliste"><span>Rückstandsliste</span></a></h1>
<p>Rückstandsliste — Listet bestellte, nicht lieferbare Artikel</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Diese Auswertung zeigt Artikel, bei denen die Auslieferung an die Kunden im Rückstand ist, d.h. bei denen die Artikelmengen in offenen Aufträgen grösser sind als die reservierten oder frei verfügbaren Mengen in den verkaufbaren Beständen eines Lagers. Aufgrund detaillierter Informationen zur Bestandes- und Bestellsituation am Lager und insgesamt können damit notwendige Massnahmen geplant werden. Der Output erfolgt in eine tabulatorgetrennte Datei (Parameter Textdatei = E) oder in eine Textdatei bzw. direkt auf den Drucker. Es ist auch möglich, die Rückstandsliste nur am Bildschirm zu betrachten.</p>
<p>Pfad: <code v-pre>Logistik → Auswertungen → Rückstandsliste</code></p>
<h2 id="parameter" tabindex="-1"><a class="header-anchor" href="#parameter"><span>Parameter</span></a></h2>
<p><strong>Parameter</strong></p>
<dl>
<dt>Lager</dt>
<dd>Lagernummer, Musseingabe</dd>
<dt>Gesamtbestand</dt>
<dd>N = Nicht berücksichtigen (= Standardvorschlag) G = Gesamtbestand ist grösser als reserviert / vorreserviert. Damit können jene Artikel aufgelistet werden, welche zwar in genügender Anzahl vorhanden wären, am Auslieferlager aber zuwenig Bestand aufweisen. Mit einer solchen Liste können Umlagerungen von Lager an Lager geplant bzw. durchgeführt werden</dd>
<dt>Artikelstatus</dt>
<dd>N = (N)icht ausverkaufte Artikel werden aufgelistet (=Standardvorschlag)<br>A = Nur (A)usverkaufte Artikel werden aufgelistet<br>T = (T)otal alle Artikel werden aufgelistet</dd>
<dt>Ausgabe</dt>
<dd>Standard (Drucker: A4-Portrait)</dd>
</dl>
<h2 id="output-liste" tabindex="-1"><a class="header-anchor" href="#output-liste"><span>Output (Liste)</span></a></h2>
<p>Die Ausgabe beinhaltet die folgenden Spalten:</p>
<table>
<thead>
<tr>
<th>Spalte</th>
<th>Bedeutung</th>
</tr>
</thead>
<tbody>
<tr>
<td>ArtNum</td>
<td>Artikelnummer</td>
</tr>
<tr>
<td>Artikelbezeichnung</td>
<td>Artikelbezeichnung</td>
</tr>
<tr>
<td>PM</td>
<td>Productmanager dieses Artikels</td>
</tr>
<tr>
<td>VBestand</td>
<td>Verkaufbarer Bestand am angegebenen Lager</td>
</tr>
<tr>
<td>nBest.</td>
<td>nächste Bestellung Artikelmenge der jüngsten zu erwartenden Lieferung für dieses Lager</td>
</tr>
<tr>
<td>Liefdat.</td>
<td>Lieferdatum, welches in der Bestellung als Zieldatum angegeben wurde, wenn mehrere Bestellungen vorhanden sind, wird das jüngste Datum angezeigt</td>
</tr>
<tr>
<td>offeneA</td>
<td>Gesamtmenge dieses Artikels in allen offenen Aufträgen für dieses Lager (Artikelpositionen im Status 1 oder 3)</td>
</tr>
<tr>
<td>S</td>
<td>Status des Artikels (A = Auslaufartikel, M = momentan nicht verfügbar)</td>
</tr>
<tr>
<td>k.Absage</td>
<td>keine Absage an den Kunden bis [Datum]. Anzeige allfällig vorhandener manueller Daten in der automatischen Avisierung</td>
</tr>
<tr>
<td>Tot.Vbestand</td>
<td>Gesamtbestand des Artikles in allen V-Partien und allen Lagern.</td>
</tr>
<tr>
<td>Tot.Bestand</td>
<td>Gesamtbestand des Artikels im angegebenen Lager aber allen Partien-Typen.</td>
</tr>
<tr>
<td>Tot.Bestellg</td>
<td>Gesamtbestellungen des Artikels in allen Lagern</td>
</tr>
<tr>
<td>BDatum</td>
<td>jüngstes erwartetes Lieferdatum aller Bestellungen</td>
</tr>
</tbody>
</table>
<div class="language-text line-numbers-mode" data-highlighter="prismjs" data-ext="text"><pre v-pre><code><span class="line"></span>
<span class="line">Datenausgabe                          18.01.2001 11:58:26 kup  Seite     0</span>
<span class="line"></span>
<span class="line"></span>
<span class="line">                               Rückstandsliste</span>
<span class="line">           Lager........: 001</span>
<span class="line">           Gesamtbestand: N Nicht berücksichtigen</span>
<span class="line">           Artikelstatus: N Nicht ausverkaufte Artikel</span>
<span class="line">           Export Format: T</span>
<span class="line"></span>
<span class="line"></span>
<span class="line">ArtNum  Artikelbezeichnung PM  VBestand    nBest Liefdat   offeneA S</span>
<span class="line">        k.Absage Tot.VBestand Tot.Bestand Tot.Bestellg Bdatum</span>
<span class="line">--------------------------------------------------------------------------</span>
<span class="line">000001  ARTIKEL 1          PM1       37      600 04.10.00       38</span>
<span class="line">                           61         124          600 04.10.00</span>
<span class="line">000002  ARTIKEL 2          PM2        0      150 21.11.00      150</span>
<span class="line">                            0           0          150 21.11.00</span>
<span class="line"></span>
<span class="line"></span></code></pre>
<div class="line-numbers" aria-hidden="true" style="counter-reset:line-number 0"><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div></div></div><p>Lesebeispiel: Der Artikel &quot;ARTIKEL 1&quot; hat noch 37 verkaufbare Stück im Lager 001. Total sind 38 Stück in offenen Aufträgen von Kunden bestellt worden. Insgesamt (d.h. auch in anderen Lagern) gibt es 61 verkaufbare Stück. D.h. durch Umlagerung von einem einzigen Stück dieses Artikels können die hängigen Aufträge weiterbearbeitet werden. Die nächste Bestellung von 600 Stück sollte am 4.10.00 eintreffen (oder zumindest die erste Teillieferung). Am Lager selbst gibt es aber noch 87 Stück (= 124 - 37) des Artikels in anderen Partien, z.B. in eine Defektpartie.</p>
</div></template>


